// extracted by mini-css-extract-plugin
export var measureBox = "_3p-0";